import { IUser } from '../interfaces';
import { BehaviorSubject, shareReplay } from 'rxjs';

export class GuestAccessStore {
  private static readonly _state$ = new BehaviorSubject<{
    enabled: boolean;
    user: IUser | null;
    token: string | null;
    isPublicApiGuest?: boolean;
  }>({
    enabled: false,
    user: null,
    token: null,
    isPublicApiGuest: false,
  });

  public static readonly state$ = this._state$.asObservable().pipe(shareReplay(1));

  public static getState() {
    return this._state$.value;
  }
  public static patchState(patch: Partial<GuestAccessStore>) {
    const newState = {
      ...this._state$.value,
      ...patch,
    };

    this._state$.next(newState);
  }
}
